import React from "react";
import { IconChevron } from "icons";
import clsx from "clsx";
import { useClickOutside } from "../../hooks/useClickOutside";

export interface ISelectOption {
  prompt: any;
  title: any;
}

interface ISelect {
  options: ISelectOption[];
  value: ISelectOption;
  onChange: (value: ISelectOption) => void;
  direction?: string;
  className?: string;
}

const Select = ({ options, value, onChange, direction = "bottom", className }: ISelect) => {
  const [show, setShow] = React.useState(false);
  const listRef = React.useRef<HTMLUListElement>(null);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const isDirectionTop = direction === "top";

  const onToggle = () => {
    setShow(!show);
  };
  const onSelect = (option: ISelectOption) => {
    onChange(option);
    onToggle();
  };
  useClickOutside(containerRef, () => {
    setShow(false);
  });

  return (
    <div className={clsx("relative", className)} ref={containerRef}>
      <div className="flex-center py-3 px-2.5 gap-2.5 text-white  border border-white border-opacity-10 bg-white bg-opacity-10 rounded-lg cursor-pointer" onClick={onToggle}>
        <span className="body-medium text-overflow">{value?.title}</span>
        <IconChevron className={clsx("transition-all duration-300 w-5 h-5")} />
      </div>
      <div
        className={clsx(
          "absolute z-10 transition-all duration-300 text-white min-w-full overflow-hidden",
          isDirectionTop ? "-translate-y-full" : "translate-y-full",
          show ? (isDirectionTop ? "-top-2" : "-bottom-2") : isDirectionTop ? "top-0" : "bottom-0"
        )}
        style={{ height: show ? `${(listRef.current?.scrollHeight as number) + 2}px` : 0 }}
      >
        <ul className="border border-white border-opacity-10 bg-bg rounded-lg divide-y-[1px] divide-white divide-opacity-10" ref={listRef}>
          {options.map((option: any, index) => {
            return (
              <li
                key={index}
                className="text-h6 py-3 px-2.5 hover:bg-white hover:bg-opacity-10 cursor-pointer divide divide-y divide-white first:rounded-t-lg last:rounded-b-lg"
                onClick={() => onSelect(option)}
              >
                {option.title}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Select;
